import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { RateInputComponent } from '../../inputs/rate-input/rate-input.component';

@Component({
  selector: 'lib-rate-form-field',
  imports: [FormErrorComponent, ReactiveFormsModule, RateInputComponent],
  templateUrl: './rate-form-field.component.html',
  styleUrl: './rate-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RateFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  autocomplete = input<string>('on');
  allowNegative = input<boolean>(false);
  inputId: string = uuidv4();
}
